import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import changeNavSelected from '../../../../redux/actions/changeNavSelected'
import PageBanner from '../../../common/PageBanner'
import Content from './Content'

const StandbyGeneratorSystem  = props => {

    useEffect(() => {
        props.changeNavSelected(4)
    }, [])

    return (
        <div className='bg-white'>
            <PageBanner title='Standby Generator System' img={{ name: 'commonBanner', type: 'jpg' }}></PageBanner>
            <Content></Content>
        </div>
    )
}

const mapStateToProps = state => { return state }
const mapDispatchToProps = { changeNavSelected }

export default connect(mapStateToProps,mapDispatchToProps)(StandbyGeneratorSystem)